import React from "react";
import CatalogTableC from "../../components/Catalogs/CatalogTableC";
import PaginatedTable from "../../components/Organismos/Table/PaginatedTable";
import ShapeEdit from "../../components/Atomos/Icons/ShapeEdit";
import useDataLoader2 from "../../hooks/useDataLoader2";
import { defaultPageSize } from "../../utils/const";
import Filters, {
  IFilterData,
} from "../../components/Catalogs/Filters/Filters";
import PersistentLink from "../../components/Moleculas/PersistentLink";
import { exportAllDataLoader2 } from "../../utils/exportAllDataLoader2";

const Company: React.FC = () => {
  const fields = ["id", "name", "logo", "squareLogo", "_ts"];
  const endpoint = "/company";

  const {
    data,
    totalCount,
    fetchData,
    setFilter,
    sort,
    setSort,
    pagination,
    setPagination,
    filter,
    inputFilters,
    setInputFilters,
  } = useDataLoader2<any>({
    endpoint,
    defaultPageSize,
    fields,
    defaultSorting: { field: "name", order: "asc" },
  });

  const columnsDef = React.useMemo(() => [
    {
      id: "count",
      header: "#",
      enableSorting: false,
      cell: ({ rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <p>
          {" "}
          {rowIndex +
            1 +
            pagination.pageIndex * pagination.pageSize}{" "}
        </p>
      ),
    },
    { id: "name", header: "Name" },
    { 
      id: "logo", 
      header: "Logo", 
      cell: ({ row }: { rowIndex: number; row: any; value: any }) => (
        <div className="flex w-10 h-10 items-center justify-center">
          <img src={row.logo} alt={row.name} className="w-full h-full object-cover" />
        </div>
      )
    },
    {
      id: "edit",
      header: "Edit",
      enableSorting: false,
      cell: ({ row }: { rowIndex: number; row: any; value: any }) => (
        <PersistentLink
          className="edit"
          to={`Edit/${row.id}`}
          state={row}
          persistingData={{
            pagination,
            sort,
            filter,
            inputFilters,
          }}
        >
          Edit{" "}
          <div className="editsvg">
            <ShapeEdit />
          </div>{" "}
        </PersistentLink>
      ),
    },
  ], [pagination.pageIndex, pagination.pageSize, sort, filter, inputFilters]);

  const filtersData: IFilterData[] = React.useMemo(
    () => [
      {
        name: "Name",
        type: "text",
        comparison: "CONTAINS",
      },
    ],
    []
  );

  return (
    <>
      <CatalogTableC
        title={`Company Catalog`}
        catalogName={"COMPANIES"}
        catalogShortName={"COMPANY"}
        route={"Company"}
        totalCount={totalCount}
      >
        <Filters
          filtersData={filtersData}
          filterValues={inputFilters}
          setFilterValues={setInputFilters}
          Search={() => fetchData()}
          clearSelections={() => fetchData(true)}
          setValueForQuery={setFilter}
        />
        <PaginatedTable
          data={data || []}
          columnsDef={columnsDef}
          sorting={sort}
          onSortingChange={setSort}
          totalCount={totalCount || 0}
          pagination={pagination}
          onPaginationChange={setPagination}
          endpoint={endpoint}
          onExportAll={() =>
            exportAllDataLoader2<any>({
              endpoint,
              filter,
              sort,
              pageSize: 1000,
              fields,
            })
          }
        />
      </CatalogTableC>
    </>
  );
};

export default Company;
